import { CUSTOMER_TYPES, PRODUCTS, REGIONS } from '@boltenergy-be/shared'
import dayjs from 'dayjs'
import { ProductPromo } from './types'

// PLENTY PROMOS
export const PRODUCT_PROMOS = [
  {
    product: PRODUCTS.plentyVariableOnline,
    availableInRegion: [REGIONS.flanders],
    code: {
      [CUSTOMER_TYPES.professional]: 'PLENTY450AND0AND10MWHINJ',
      [CUSTOMER_TYPES.residential]: 'PLENTY350AND230AND10MWHINJ'
    },
    period: {
      start: dayjs('2026-09-01').startOf('day'),
      end: dayjs('2026-09-01').endOf('month')
    }
  },
  {
    product: PRODUCTS.plentyFix,
    availableInRegion: [REGIONS.flanders],
    code: {
      [CUSTOMER_TYPES.professional]: '',
      [CUSTOMER_TYPES.residential]: 'PLENTY300AND0AND10MWHINJ'
    },
    period: {
      start: dayjs('2026-09-01').startOf('day'),
      end: dayjs('2026-09-01').endOf('month')
    }
  }
] as const satisfies ProductPromo[]

export const PRODUCT_PROMO_CODES = new Set<string>(
  PRODUCT_PROMOS.map(({ code }) => [code[CUSTOMER_TYPES.professional], code[CUSTOMER_TYPES.residential]])
    .flat()
    .filter(Boolean)
)
